/** @jsx jsx */
import React from 'react'
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import { ScoreTimelineItemWrap } from '@views/Matchup/MatchUpDetail/index.style'
import goalTxtImg from '@assets/images/bg/dash-board/goal-txt.png'
import _ from 'lodash'

interface ScoreTimelineData {
  teamName: string
  time: number
  playerName: string
  teamEmblemUrl: string
}

interface ScoreTimelineItemProps {
  scoreTimelineData: ScoreTimelineData
  className?: string
}

export const ScoreTimelineItem: React.FC<ScoreTimelineItemProps> = observer(({ scoreTimelineData, className  }) => {
  const { teamName = '', time = '', playerName = '', teamEmblemUrl } = scoreTimelineData

  const timeStr = time?.toString() ?? ''
  const minutes = timeStr?.slice(0, -3) ?? ''

  return (
    <ScoreTimelineItemWrap className={className}>
      <div className="info-txt">
        <img src={goalTxtImg} alt="GOAL!" loading="lazy"/>
        {_.size(minutes) > 0 && <span className="time-info">{minutes}&#39;</span>}
      </div>
      <div className="score-time-line-item">
        <span className="team-name">{teamName}</span>
        <span className="player-name">{playerName}</span>
        <span className="emblem-img-bg">
          {teamEmblemUrl && <img src={teamEmblemUrl} alt={teamName} />}
        </span>
      </div>
    </ScoreTimelineItemWrap>
  )
})
